module.exports = __webpack_public_path__ + "static/media/bg-1.28359df2.png";